import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "demka_cookie_consent_v1";

export default function CookieConsent() {
  const [choice, setChoice] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY); } catch { return null; }
  });
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!choice) {
      const t = setTimeout(() => setShow(true), 800);
      return () => clearTimeout(t);
    }
  }, [choice]);

  const persist = (value) => {
    try { localStorage.setItem(STORAGE_KEY, value); } catch { /* ignore */ }
    setChoice(value);
    setShow(false);
  };

  if (!show || choice) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 sm:max-w-md z-[60] animate-fade-up" data-testid="cookie-consent">
      <div className="bg-white rounded-2xl border border-primary/20 shadow-2xl overflow-hidden">
        <div className="pattern-band" />
        <div className="p-5">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Cookie className="w-5 h-5 text-primary" />
            </div>
            <div className="flex-1">
              <h3 className="font-display font-bold text-base mb-1">Vos préférences de confidentialité</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                DemkaBiz utilise des cookies essentiels au bon fonctionnement de la plateforme (authentification, sécurité) et des cookies de mesure d'audience anonyme.
                Conformément à la <strong>Loi 25 du Québec</strong>, vous pouvez accepter ou refuser ces derniers.
              </p>
            </div>
          </div>
          <div className="mt-4 flex flex-col sm:flex-row gap-2">
            <button onClick={() => persist("accepted")} className="btn-primary text-sm py-2.5 px-4 flex-1" data-testid="cookie-accept">
              Tout accepter
            </button>
            <button onClick={() => persist("essential_only")} className="btn-outline text-sm py-2.5 px-4 flex-1" data-testid="cookie-essential">
              Essentiels seulement
            </button>
          </div>
          <div className="mt-3 text-center">
            <Link to="/cookies" onClick={() => setShow(false)} className="text-xs text-muted-foreground hover:text-primary underline">
              En savoir plus sur notre politique
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export function getCookieConsent() {
  try { return localStorage.getItem(STORAGE_KEY); } catch { return null; }
}
